import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Modal,
  OverlayTrigger,
  Row,
  Stack,
  Tooltip,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import debounce from "lodash.debounce";
import { RootState } from "../../../../redux/Store";
import AccordionComponent from "../../../../common/Accordion";
import SearchInput from "../../../../common/InlineSearch";
import DataTable from "../../../../common/DataTable";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import EditableFileTable from "../../../../common/RecordFileUploadDataTable";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  addUploadRecordHeader,
  downloadZipFileForDocumentCategory,
  downloadZipFileForHeader,
  downloadZipFileForPopUpDetails,
  fetchDocumentTypeListForReviewer,
  getDownloadFileForPopUpDetails,
  getRecordListPopUpDetails,
} from "../../../../services/UploadRecordsApi";
import { fetchPartiesDetails } from "../../../../services/CaseInformationApi";
import {
  APPROVAL_LIST_HEADERS,
  APPROVE_REWORK_LOGS_HEADERS,
  DOCTOR_FILE_HEADERS,
  DOCTOR_RECORD_LIST_HEADERS,
} from "../actions/constant";
import Loader from "../../../../common/Loader";
import Snackbar from "../../../../common/Snackbar";
import UploadStatusFloatingIcon from "../../../../common/UploadStatusFloatingIcon";
import PdfViewerDrawer from "../../../../common/PDFFileViewerDrawer";
import DataTableForList from "../../../../modules/Case_Management/Case_Records/components/ExpandableTable";
import {
  editorReportStatusUpdate,
  getEditorRecordList,
  getEditorRecordListSummary,
} from "../../../../services/EditorWorkFlowAPI";
import {
  downloadZipFileForRecordDownloadAll,
  getApproveReworkLogsList,
  updateQMEDoctorStatus,
} from "../../../../services/DoctorWorkflowAPI";
import HistorianRecordEditableTable from "../../Historian/components/HistorianRecordEditableTable";
import { EDITOR_REPORT_STATUS } from "../../../../common/Constant";

interface DoctorApproveReworkProps {
  doctorData: any[];
  selectedRowsData: any;
  onClose: () => void;
}

interface DocumentTypeOption {
  value: string;
  label: string;
  documentCategory: string;
  documentTypeDescription: string;
}

interface RecordSummary {
  dataCategory: string;
  totalRecords: number;
  lastUploadedBy: string;
  lastUploadedOn: string;
  keyID: number;
  categoryWiseTotalPageCount: number;
  keyId?: number;
  datacategory?: string;
}

interface DownloadStatus {
  fileName: string;
  progress: number;
  isUploading: boolean;
}

const getStatusColor = (status: string) => {
  switch (status) {
    case EDITOR_REPORT_STATUS.OVERDUE:
      return "#FF0000";
    case EDITOR_REPORT_STATUS.APPROVED_BY_DOCTOR:
      return "#0092d5";
    case EDITOR_REPORT_STATUS.EDITING_PENDING:
      return "#197a72ff";
    case EDITOR_REPORT_STATUS.EDITING_IN_PROGRESS:
      return "#ffc117ff";
    case EDITOR_REPORT_STATUS.SENT_FOR_REWORK:
      return "#ffc117ff";
    case EDITOR_REPORT_STATUS.COMPLETED:
      return "#0E8536";
    default:
      return "#000000"; 
  }
};

const DoctorApproveRework: React.FC<DoctorApproveReworkProps> = ({
  doctorData,
  selectedRowsData,
  onClose,
}) => {
  const caseInfo = doctorData[0] || {};
  const {
    caseId,
    patientName: patient,
    appointmentDateTime: Appointment_Date_Time,
    caseInfoId,
    subjectQmeScheduleId: subjectQmeScheduleID,
    reportStatus,
  } = caseInfo;
  
  const isDisableButton = [EDITOR_REPORT_STATUS.COMPLETED, EDITOR_REPORT_STATUS.APPROVED_BY_DOCTOR, EDITOR_REPORT_STATUS.SENT_FOR_REWORK, EDITOR_REPORT_STATUS.EXCEPTION, "Approved By Doctor"].includes(reportStatus);  
  const searchInputRef = useRef<any>(null);
  const loggedInUserId = useSelector((state: RootState) => state.auth.userid);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [activeAccordionKeys, setActiveAccordionKeys] = useState<string[]>([]);
  const [attachmentKey, setattachmentKey] = useState<string | null>("0");
  const [recordListKey, setRecordListKey] = useState<string | null>("0");
  const [recordListLogsKey, setRecordListLogsKey] = useState<string | null>("");
  const [showApprovalModal, setShowApprovalModal] = useState<boolean>(false);
  const [showReworkModal, setShowReworkModal] = useState<boolean>(false);
  const [isAddAttachmentChecked, setIsAddAttachmentChecked] =
    useState<boolean>(false);
  const [comments, setComments] = useState<string>("");
  const [reworkComments, setReworkComments] = useState<string>("");
  const [attachmentComments, setAttachmentComments] = useState<string>("");
  const [result, setResult] = useState<any>({});
  const [isCancel, setIsCancel] = useState<boolean>(false);

  const [recordSummaries, setRecordSummaries] = useState<RecordSummary[]>([]);
  const [recordListsByCategory, setRecordListsByCategory] = useState<
    Record<string, any[]>
  >({});
  const [recordListsByCategoryTotalRows, setRecordListsByCategoryotalRows] =
    useState<Record<string, any[]>>({});
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    DocumentTypeOption[]
  >([]);
  const [senderOptions, setSenderOptions] = useState<any[]>([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState<
    string | number | null
  >(null);
  const [selectedSender, setSelectedSender] = useState<string | number | null>(
    null
  );
  const [openViwer, setOpenViwer] = useState<string>("");
  const [senderCode, setSenderCode] = useState<string>("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(false);

  const [approveReworkLogs, setApproveReworkLogs] = useState<any[]>([]);
  const [approvedList, setApprovedList] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [downloadStatuses, setDownloadStatuses] = useState<
    Record<string, DownloadStatus>
  >({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState<string | null>(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState<string>("");
  const [selectedClientName, setSelectedClientName] = useState<string>("");
  const [totalPageCount, setTotalPageCount] = useState<number | null>(null);
  const [popUpListResult, setPopUpListResult] = useState<any[]>([]);
  const [isOnSaveDisable, setIsOnSaveDisable] = useState<boolean>(false);

  const debouncedSearch = useRef(
    debounce((query: string) => {
      handleSearch(query);
    }, 500)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const initializeData = async () => {
    try {
      setIsOnSaveDisable(false);
      await fetchRecordSummaries();

      const [docTypes, parties] = await Promise.all([
        fetchDocumentTypeListForReviewer(),
        fetchPartiesDetails(caseInfoId),
      ]);

      setDocumentTypeOptions(docTypes || []);
      setSenderOptions(parties || []);
      const selectedDocType = docTypes?.find(
        (item: any) => item.label === "QME Report Feedback"
      );
      setSelectedDocumentType(selectedDocType?.value || null);
      const selectedParty = parties?.find(
        (item: any) => item.value === String(loggedInUserId)
      );

      if (selectedParty) {
        setSelectedSender(selectedParty.value);
        setSenderCode(selectedParty.partyCode || "");
      }
    } catch (error) {
      console.error("Error initializing data:", error);
    }
  };

  useEffect(() => {
    if (subjectQmeScheduleID && caseInfoId) {
      initializeData();
    }
  }, [subjectQmeScheduleID]);

  useEffect(() => {
    if (!isAddAttachmentChecked) {
      resetAttachmentSection();
    }
  }, [isAddAttachmentChecked]);

  const fetchRecordSummaries = async (searchTerm: string = "") => {
    try {
      const [summaryData, logsData] = await Promise.all([
        getEditorRecordListSummary(caseInfoId, subjectQmeScheduleID),
        getApproveReworkLogsList(subjectQmeScheduleID),
      ]);

      const summaries = summaryData?.result || [];
      setRecordSummaries(summaries);
      setApproveReworkLogs(logsData?.result || []);

      if (summaries?.length > 0) {
        const allKeys = summaries?.map((_: any, index: number) =>
          index.toString()
        );
        setActiveAccordionKeys(allKeys);
        setIsExpanded(true);

        await fetchRecordListsForAllCategories(summaries);
      }
    } catch (error) {
      console.error("Error fetching record summaries:", error);
    }
  };

  const fetchRecordListsForAllCategories = async (
    summaries: RecordSummary[]
  ) => {
    const promises = summaries.map(({ keyID, dataCategory }) =>
      getEditorRecordList(caseInfoId, keyID, subjectQmeScheduleID).then(
        (res: any) => ({
          category: dataCategory,
          data: res?.result || [],
        })
      )
    );

    const results = await Promise.all(promises);
    const recordMap: Record<string, any[]> = {};

    results?.forEach(({ category, data }: any) => {
      recordMap[category] = data;
    });

    setRecordListsByCategory(recordMap);
    setRecordListsByCategoryotalRows(recordMap);
  };

  const fetchRecordListForCategory = async (
    category: string,
    keyId: number
  ) => {
    try {
      const response = await getEditorRecordList(
        caseInfoId,
        keyId,
        subjectQmeScheduleID
      );

      setRecordListsByCategory((prev) => ({
        ...prev,
        [category]: response?.result || [],
      }));
    } catch (error) {
      console.error(`Error fetching records for ${category}:`, error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleSearch = async (query: string) => {
    const trimmedQuery = query?.trim();
    setSearchQuery(trimmedQuery);
    await fetchRecordSummaries(trimmedQuery);
  };

  const handleSearchQueryChange = (query: string) => {
    const trimmedQuery = query?.trim();
    setSearchQuery(trimmedQuery);

    if (trimmedQuery === "") {
      debouncedSearch.cancel();
      fetchRecordSummaries();
    } else {
      debouncedSearch(trimmedQuery);
    }
  };

  const handleResetSearch = () => {
    searchInputRef.current?.clear();
    setSearchQuery("");
    fetchRecordSummaries();
  };

  const toggleAllAccordions = async () => {
    if (isExpanded) {
      setActiveAccordionKeys([]);
      setIsExpanded(false);
    } else {
      const allKeys = recordSummaries.map((_, index) => index.toString());
      setActiveAccordionKeys(allKeys);
      setIsExpanded(true);

      await Promise.all(
        recordSummaries.map(({ keyID, dataCategory }) =>
          fetchRecordListForCategory(dataCategory, keyID)
        )
      );
    }
  };

  const handleAccordionToggle = async (
    key: string,
    dataCategory: string,
    keyId: number
  ) => {
    setActiveAccordionKeys((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      }
      return [...prev, key];
    });

    if (!recordListsByCategory[dataCategory]) {
      await fetchRecordListForCategory(dataCategory, keyId);
    }
  };

  const handleFileIdsUpdate = (ids: string[], saveDisabled?: boolean) => {
    setFileIds(ids);
    setIsSaveDisabled(saveDisabled || false);
  };

  const handleViwerOpen = (open: string) => {
    setOpenViwer(open)
  };

  const resetAttachmentSection = () => {
    setAttachmentComments("");
    setIsCancel(false);
    setResult({});
    setFileIds([]);
  };

  const handleAttachmentCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIsAddAttachmentChecked(e.target.checked);
    setattachmentKey("0");
  };

  const handleCloseModals = () => {
    setShowApprovalModal(false);
    setShowReworkModal(false);
    setIsAddAttachmentChecked(false);
    setComments("");
    setReworkComments("");
    setApprovedList([]);
    setOpenViwer("");
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip"
  ) => {
    setDownloadStatuses((prev) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress = Math.min(progress + 10, 90);
      setDownloadStatuses((prev) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);

      setDownloadStatuses((prev) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));

      setTimeout(() => {
        setDownloadStatuses((prev) => {
          const { [id]: _, ...rest } = prev;
          return rest;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleDownloadAll = () => {
    handleDownloadProgress(caseInfoId.toString(), () =>
      downloadZipFileForRecordDownloadAll(caseInfoId, subjectQmeScheduleID)
    );
  };

  const handleHeaderFileDownload = (datacategory: string, keyId: number) => {
    const ids = (recordListsByCategory[datacategory] || [])
      .map((item) => item.caseRecordHeaderID)
      .join(",");

    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(ids, 1, "")
    );
  };

  const handlePopUpDetailsFileDownloadAction = () => {
    const ids = popUpListResult
      .map((item) => item.caseRecordDetailsId)
      .join(",");
    handleDownloadProgress(`popup-${Date.now()}`, () =>
      downloadZipFileForPopUpDetails(ids)
    );
  };

  const handleDownloadAction = (row: any) => {
    handleDownloadProgress(
      row?.caseRecordDetailsId,
      () =>
        getDownloadFileForPopUpDetails(row?.caseRecordDetailsId, row?.fileName),
      row?.fileName
    );
  };

  const fetchPopUpListDetails = async (
    caseRecordHeaderId: number,
    tagType: string
  ) => {
    try {
      const popUpListData = await getRecordListPopUpDetails(
        caseRecordHeaderId,
        tagType
      );
      setPopUpListResult(popUpListData?.result || []);
      setTotalPageCount(
        (popUpListData?.result?.[0] as any)?.totalPageCount || null
      );
    } catch (error) {
      console.error("Error fetching record list data:", error);
    }
  };

  const handleFileAction = (row: any) => {
    setPopUpListResult([]);
    setTotalPageCount(null);
    setSelectedFileName('');
    setSelectedClientName('');
    fetchPopUpListDetails(row.caseRecordHeaderID, row.tagType);
    setShowModalNew(true);
    setSelectedFileName(row?.documentTypeName);
    setSelectedClientName(row?.senderKeyName);
  };

  const validatationForRework = () => {
    const errors = [];

    if (!reworkComments) {
      errors.push("Please add Comments");
    }

    if (!selectedDocumentType && isAddAttachmentChecked) {
      errors.push("Please select Document Type.");
    }

    if (!selectedSender && isAddAttachmentChecked) {
      errors.push("Please select Sender.");
    }

    const hasAttachments = fileIds && fileIds?.length > 0;

    if (
      !hasAttachments &&
      selectedDocumentType &&
      selectedSender &&
      isAddAttachmentChecked
    ) {
      errors.push("Please upload attachments.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmitApproval = async () => {
    if (!comments) {
      setSnackbarMessage("Please add Comments");
      setSnackbarOpen(true);
      setError("error");
      return;
    }

    const payloadStatusReport = {
      subjectQmeScheduleId: subjectQmeScheduleID || null,
      editorComments: comments?.trim() || "",
      isApprovedStatus: 1,
    };

    const payloadReport = {
      subjectQmeScheduleID: subjectQmeScheduleID,
      reportStatus: EDITOR_REPORT_STATUS.COMPLETED,
    };

    try {
      setIsOnSaveDisable(true);
      const response = await updateQMEDoctorStatus(payloadStatusReport);
      if (response?.isSuccess) {
        const editorReportStatus = await editorReportStatusUpdate(payloadReport);
        if (editorReportStatus?.isSuccess) {
          setSnackbarMessage("QME Draft Report has been Approved.");
          setError("success");
          setSnackbarOpen(true);
          setTimeout(() => {
            onClose();
          }, 800);
        } else {
          setSnackbarMessage(editorReportStatus?.message || "Failed to approve QME Draft Report.");
          setError("error");
          setSnackbarOpen(true);
          setIsOnSaveDisable(false);
        }
      } else {
        setSnackbarMessage(
          response?.message || "Failed to approve QME Draft Report.",
        );
        setError("error");
        setSnackbarOpen(true);
        setIsOnSaveDisable(false);
      }
    } catch (error) {
      console.error("Error processing data:", error);
      setSnackbarMessage("Something went wrong. Please try again.");
      setSnackbarOpen(true);
      setError("error");
      setIsOnSaveDisable(false);
    } finally {
      setLoading(false);
      setShowApprovalModal(false);
      setIsOnSaveDisable(false);
    }
  };

  const handleSubmitRework = async () => {
    if (!validatationForRework()) return;
    setLoading(true);
    const payloadAdd = {
      caseInfoId: caseInfoId,
      documentTypeId: selectedDocumentType || null,
      additionalComments: reworkComments?.trim() || "",
      provisionalIds: fileIds.join(", ") || "",
      senderKeyId: Number(selectedSender) || null,
      subjectQmeScheduleId: Number(subjectQmeScheduleID) || null,
      senderKeyCode: senderCode || "",
      createdBy: loggedInUserId,
    };

    const payloadStatusReport = {
      subjectQmeScheduleId: subjectQmeScheduleID || null,
      editorComments: reworkComments?.trim() || "",
      isApprovedStatus: 0,
    };

    try {
      setIsOnSaveDisable(true);
      const response = await addUploadRecordHeader(payloadAdd);
      if (response?.isSuccess) {
        await updateQMEDoctorStatus(payloadStatusReport);
        setSnackbarMessage("QME Draft Report has been sent for Rework.");
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
        }, 800);
      } else {
        setSnackbarMessage(response?.message || "Failed to rework QME Draft Report.");
        setError("error");
        setSnackbarOpen(true);
        setIsOnSaveDisable(false);
      }
    } catch (error) {
      console.error("Error processing data:", error);
      setSnackbarMessage("Something went wrong. Please try again.");
      setSnackbarOpen(true);
      setError("error");
      setIsOnSaveDisable(false);
    } finally {
      setLoading(false);
      setShowReworkModal(false);
      setIsOnSaveDisable(false);
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-US");
  };

  const viewPDF = (row: any) => {
    const fileUrl = row.download;
    const isPdf = fileUrl?.toLowerCase().endsWith(".pdf");
    const isImage = /\.(png|jpe?g|gif|tiff?|heif|heic|webp)$/i.test(
      fileUrl || ""
    );

    if (isPdf || isImage) {
      setSelectedPdfUrl(fileUrl);
      setIsViewerOpen(true);
    } else {
      alert("Unsupported file format");
    }
  };

  const formatClientName = (name: any) => {
    // Get the name before the first `[` or comma
    const namePart = name.split(/[\[,]/)[0].trim();
    // Extract the first tag inside square brackets (e.g., Client, Defence)
    const tagMatch = name.match(/\[(.*?)\]/);
    const tag = tagMatch ? tagMatch[1].trim() : null;
    // If there's a tag, append it with "Attorney"
    const formattedSuffix = tag ? ` (${tag})` : "";

    return namePart + formattedSuffix;
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
    setSelectedFileName("");
    setSelectedClientName("");
    setTotalPageCount(null);
  };

  const renderRecordListAccordion = () => {
    if (recordSummaries?.length === 0) {
      return (
        <Row>
          <span className="no_rec_data">No Record Found</span>
        </Row>
      );
    }

    return (
      <AccordionComponent
        items={recordSummaries.map((summary, index) => ({
          title: (
            
              <div className="d-flex align-items-center w-100">
               <div className="d-flex  justify-content-start me-auto">
                  <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{summary.dataCategory}</Tooltip>}
                >
                  <span className="text-truncate w-50">
                    {summary.dataCategory}
                  </span>
                </OverlayTrigger>

                <Badge bg="primary" className="ms-2 primary-badge">
                  {summary.totalRecords}
                </Badge>

                {summary.categoryWiseTotalPageCount != null && (
                  <>
                    <span className="ms-3 material-icons theme-color">
                      auto_stories
                    </span>
                    <span
                      className="ms-1 theme-color mx-1 fw-light"
                      style={{ width: "55px", textAlign: "left" }}
                    >
                      Pages -
                    </span>
                    <span className="text-muted">
                      {summary.categoryWiseTotalPageCount}
                    </span>
                  </>
                )}

               </div>
                  <div className="fw-normal d-flex  accord-righttext justify-content-end">
                <div className="d-flex align-items-center ">
                  <span
                    className="me-2"
                    style={{ width: "100%", display: "inline-flex",justifyContent: "flex-end",}}
                  >
                    <span
                      style={{
                        width: "100%",
                        marginTop: "5px",
                        display: "inline-block",
                        textAlign: "right",
                        paddingRight: "10px",
                       
                      }}
                    >
                      Last Uploaded On: {formatDate(summary.lastUploadedOn)}
                      


                    </span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{summary.lastUploadedBy}</Tooltip>}
                    >
                      <span
                        className="theme-color text-truncate"
                        style={{
                          width: "auto",
                          
                          marginTop: "5px",
                          textAlign:'right'
                        }}
                      >
                        | {summary.lastUploadedBy}
                      </span>
                    </OverlayTrigger>
                  </span>

                  <Button
                    variant="primary"
                    size="sm"
                    className="d-flex align-items-center me-2 px-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleHeaderFileDownload(
                        summary.dataCategory,
                        summary.keyID
                      );
                    }}
                  >
                    <span className="material-icons">download</span>
                  </Button>
                </div>
                  </div>

              </div>

            
         
          ),
          content: (
            <div className="doctor_grid">
              {recordListsByCategory[summary.dataCategory]?.length ? (
                <DataTable
                  key={`table-${summary.dataCategory}-${index}`}
                  headers={DOCTOR_RECORD_LIST_HEADERS}
                  rows={recordListsByCategory[summary.dataCategory]}
                  onFileAction={handleFileAction}
                />
              ) : (
                <Row>
                  <span className="no_rec_data">No Record Found</span>
                </Row>
              )}
            </div>
          ),
          eventKey: index.toString(),
        }))}
        activeKey={activeAccordionKeys}
        onSelect={(key: any) => {
          const index = parseInt(key || "0");
          const summary = recordSummaries[index];
          if (summary) {
            handleAccordionToggle(key, summary.dataCategory, summary.keyID);
          }
        }}
      />
    );
  };

  const totalRows = Object.values(recordListsByCategoryTotalRows)?.reduce(
    (sum, rows) => sum + (Array.isArray(rows) ? rows.length : 0),
    0
  );

  const isSaveShow = isDisableButton || totalRows === 0;

  return (
    <>
      <div className="breadcrumbg pb-0">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Col className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>APPROVE/REWORK REPORT</h4>
            </Col>

            <div className="status_row">
              <h6
                className="fade-in-right mt-1 d-flex align-items-center"
                style={{ lineHeight: "15px" }}
              >
                <span className="caseinfoDoctor">Case ID</span>:{" "}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    caseId?.length > 20 ? <Tooltip>{caseId}</Tooltip> : <></>
                  }
                >
                  <span className="casedetail text-truncate ms-1">
                    {caseId}
                  </span>
                </OverlayTrigger>
              </h6>

              {patient && (
                <h6 className="fade-in-right d-flex align-items-center">
                  <span className="caseinfoDoctor">Patient</span>:{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      patient?.length > 20 ? (
                        <Tooltip>{patient}</Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span className="casedetail text-truncate ms-1">
                      {patient}
                    </span>
                  </OverlayTrigger>
                </h6>
              )}

              {Appointment_Date_Time && (
                <h6 className="fade-in-right d-flex align-items-center">
                  <span className="caseinfoDoctor">
                    Appointment Date & Time
                  </span>
                  :{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      Appointment_Date_Time?.length > 20 ? (
                        <Tooltip>{Appointment_Date_Time}</Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span className="casedetail text-truncate ms-1">
                      {Appointment_Date_Time}
                    </span>
                  </OverlayTrigger>
                </h6>
              )}
            </div>
          </Stack>
        </Container>
      </div>
      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id: any) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />
      <div className="main_wrapper_section pills_wrapper px-5 mb-3 mt-3 fade-in-left">
        <Row className="mt-3 align-items-center px-2 py-1">
          <Col className="d-flex align-items-center border-bottom pb-2 px-0 mb-2">
            <h3 className="me-auto mb-0 d-flex align-items-center">
              QME Draft Reports
            </h3>
            <h3 className="me-3">Report Status</h3>
            <span
              className="me-4 statusPill"
              style={{ color: getStatusColor(reportStatus) }}
            >
              {reportStatus}
            </span>

            {/* <div className="d-flex search_closer">
              <div style={{ width: "80%" }} className="gridsearch">
                <SearchInput
                  ref={searchInputRef}
                  data={[]}
                  searchKeys={[]}
                  onSearchResult={() => {}}
                  placeholder="Search"
                  onSearchQueryChange={handleSearchQueryChange}
                />
              </div>
              <button
                onClick={handleResetSearch}
                className="reset_btn"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
              >
                <span className="material-icons reset_ic0">restart_alt</span>
              </button>
            </div> */}

            <Button
              variant="primary"
              className="border-top d-flex justify-content-end px-1"
              style={{ marginRight: "44px", padding: "7px 5px" }}
              onClick={handleDownloadAll}
            >
              <span className="material-icons">download</span>
            </Button>

            <button
              type="button"
              className="btn d-flex align-items-center btn-text-border float-end position-absolute"
              onClick={toggleAllAccordions}
              style={{ right: "48px", padding: "7px 5px" }}
            >
              <span className="material-symbols-outlined">
                {isExpanded ? "collapse_all" : "expand_all"}
              </span>
            </button>
          </Col>
        </Row>

        <AccordionComponent
          items={[
            {
              title: "Record List",
              content: renderRecordListAccordion(),
            },
          ]}
          activeKey={recordListKey}
          onSelect={(key) => setRecordListKey(key as string)}
        />

        {!isSaveShow ? (
          <Row className="mb-3 mt-3">
            <Col className="d-flex justify-content-end">
              <Button
                variant="outline-info"
                className="d-flex align-items-center m-0"
                onClick={() => setShowReworkModal(true)}
                disabled={isDisableButton || totalRows === 0}
              >
                <span className="material-icons mr-2">autorenew</span> Rework
              </Button>
              <Button
                type="submit"
                variant="primary"
                className="d-flex align-items-center mx-2"
                onClick={() => setShowApprovalModal(true)}
                disabled={isDisableButton || totalRows === 0}
              >
                <span className="material-icons mx-1">check</span> Approve
              </Button>
            </Col>
          </Row>
        ) : (
          ""
        )}

        <AccordionComponent
          items={[
            {
              title: "Approve / Rework Logs",
              content: (
                <Row>
                  <DataTable
                    headers={APPROVE_REWORK_LOGS_HEADERS}
                    rows={approveReworkLogs}
                  />
                </Row>
              ),
            },
          ]}
          activeKey={recordListLogsKey}
          onSelect={(key) => setRecordListLogsKey(key as string)}
        />

        <Col className="d-flex justify-content-start">
          <Button
            variant="outline"
            className="d-flex align-items-center btn-text-border me-1 mb-4"
            onClick={handleClose}
          >
            <span className="material-icons mr-2">arrow_back</span>
            Back
          </Button>
        </Col>
      </div>

      <Loader isLoading={loading} />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />

      <Modal
        show={showApprovalModal}
        onHide={handleCloseModals}
        size="xl"
        centered
        className="confirm_modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fw-bold w-100 text-center">
            <span className="border associated-location-count text-primary badgeCountNu">
              {totalRows}
            </span>{" "}
            <span className="approvalTitle">QME Draft Report Approval</span>
          </Modal.Title>
        </Modal.Header>

        <div className="text-center text-muted mb-3">
          Review the selected reports before confirming approval.
        </div>

        <Modal.Body className="pt-0">
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255, 255, 255, 0.6)",
                zIndex: 1056,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Loader isLoading={true} />
            </div>
          )}
          <Row className="mb-3">
            <Col sm={12}>
              <MultilineTextBox
                label="Comments"
                name="comments"
                value={comments}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value.trimStart().replace(/ {2,}/g, " ");
                  setComments(value);
                }}
                maxLength={300}
                required
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end gap-2">
          <Button
            variant="outline-info"
            onClick={handleCloseModals}
            className="d-flex align-items-center"
            disabled={isOnSaveDisable}
          >
            <span className="material-icons me-1">close</span>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="d-flex align-items-center"
            onClick={handleSubmitApproval}
            disabled={isOnSaveDisable}
          >
            <span className="material-icons me-1">save</span>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showReworkModal}
        onHide={handleCloseModals}
        size="xl"
        centered
        className={`recordList ${
          openViwer == "Open" ? "divVisiblityHidden" : ""
        }`}
        backdropClassName={openViwer === "Open" ? "divVisiblityHidden" : ""}
      >
        <Modal.Header closeButton className="d-flex">
          <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
            Rework on QME Report
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="fw-bold text-left modelheading"
          style={{ position: "relative" }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255, 255, 255, 0.6)",
                zIndex: 1056,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Loader isLoading={true} />
            </div>
          )}
          <div className="mb-3">
            <input
              type="checkbox"
              checked={isAddAttachmentChecked}
              onChange={handleAttachmentCheckboxChange}
            />
            <span style={{ marginLeft: "10px" }}>Add an attachment</span>
          </div>

          {isAddAttachmentChecked && (
            <AccordionComponent
              items={[
                {
                  title: "Attachment(s)",
                  content: (
                    <>
                      <Row>
                        <Col sm={6} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Document Type"
                            name="documentType"
                            options={documentTypeOptions}
                            value={selectedDocumentType}
                            onChange={(e, name, value) => {
                              setSelectedDocumentType(value);
                            }}
                            disabled
                          />
                        </Col>
                        <Col sm={6} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Sender"
                            name="sender"
                            options={senderOptions}
                            value={selectedSender}
                            onChange={(e, name, value) => {
                              setSelectedSender(value);
                              const selected = senderOptions.find(
                                (item) => item.value === value
                              );
                              setSenderCode(selected?.partyCode || "");
                            }}
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className="align-items-center mt-3">
                        <HistorianRecordEditableTable
                          caseInfoId={caseInfoId}
                          comments={attachmentComments}
                          onFileIdsUpdate={handleFileIdsUpdate}
                          result={result}
                          isCancel={isCancel}
                          documentType={selectedDocumentType}
                          isRowActionTriggered={false}
                          onViwerOpen={handleViwerOpen}
                        />
                      </Row>
                    </>
                  ),
                },
              ]}
              activeKey={attachmentKey}
              onSelect={(key) => setattachmentKey(key as string)}
            />
          )}

          <Row className="mt-3">
            <Col sm={12}>
              <MultilineTextBox
                label="Comments"
                name="comments"
                value={reworkComments}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setReworkComments(value);
                }}
                maxLength={300}
                required
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModals}
            disabled={isOnSaveDisable}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="d-flex align-items-center"
            onClick={handleSubmitRework}
            disabled={isOnSaveDisable}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Modal.Footer>
      </Modal>

      {!isViewerOpen ? (
        <Modal
          show={showModalNew}
          onHide={handleCloseModalNew}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="recordList"
        >
          <Modal.Header closeButton className="d-flex">
            <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
              View Attachments{" "}
              <span className="text-dark fw-normal mx-1">
                {selectedFileName && selectedClientName ? (
                  <>
                    - {selectedFileName} -{" "}
                    <span style={{ fontWeight: "bold" }}>
                      {formatClientName(selectedClientName)}
                    </span>
                  </>
                ) : (
                  ""
                )}
              </span>
              {totalPageCount != null && (
                <>
                  <span className="ms-3 material-icons theme-color">
                    auto_stories
                  </span>
                  <span className="ms-1 theme-color">Pages -</span>{" "}
                  <span className="text-muted">{totalPageCount}</span>
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DataTableForList
              headers={DOCTOR_FILE_HEADERS}
              rows={popUpListResult}
              // children_headers={VERSION_HEADER}
              onDownloadAction={handleDownloadAction}
              onViewPdf={viewPDF}
            />
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              onClick={handleCloseModalNew}
              className="d-flex align-items-center btn btn-outline-info"
            >
              <span className="material-icons mr-2">close</span> Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-primary d-flex align-items-center mx-2 btn btn-primary"
              onClick={handlePopUpDetailsFileDownloadAction}
            >
              <span className="material-icons mx-1">download</span> Download All
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}

      <PdfViewerDrawer
        isOpen={isViewerOpen}
        onClose={() => setIsViewerOpen(false)}
        fileUrl={selectedPdfUrl}
      />
    </>
  );
};

export default DoctorApproveRework;
